import { render, staticRenderFns } from "./BaseEmailInput.vue?vue&type=template&id=70b33a3a&scoped=true&"
import script from "./BaseEmailInput.vue?vue&type=script&lang=js&"
export * from "./BaseEmailInput.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/base.css?vue&type=style&index=0&id=70b33a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b33a3a",
  null
  
)

export default component.exports